import { Link } from "react-router-dom";
import { SAFE_BAND_URL, LOGO } from "@/lib/assets";

export default function Footer() {
  return (
    <footer
      data-testid="main-footer"
      className="relative z-[2] border-t border-zinc-800 bg-[#0a0a0a]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Link
            to="/"
            className="font-heading text-2xl font-semibold tracking-tight flex items-center gap-3"
          >
            <img loading="lazy" src={LOGO} alt="WearSpray logo" className="w-10 h-10 object-contain" />
            <span>Wear<span className="text-accent">Spray</span></span>
          </Link>
          <p className="font-body text-zinc-500 mt-4 max-w-sm leading-relaxed">
            An innovation platform advancing accessible, everyday protection
            through patented wearable dispensing technology.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono text-xs tracking-[0.2em] uppercase text-zinc-500 mb-5">
            Navigate
          </p>
          <ul className="space-y-3 font-body text-sm">
            <li><Link to="/platform" data-testid="footer-platform-link" className="text-zinc-400 hover:text-white transition-colors">Platform</Link></li>
            <li><Link to="/intelligence" data-testid="footer-intelligence-link" className="text-zinc-400 hover:text-white transition-colors">Technology</Link></li>
            <li><Link to="/clinical" data-testid="footer-clinical-link" className="text-zinc-400 hover:text-white transition-colors">Clinical Recovery & Aesthetics</Link></li>
            <li><Link to="/applications" data-testid="footer-applications-link" className="text-zinc-400 hover:text-white transition-colors">Applications</Link></li>
            <li><Link to="/patents" className="text-zinc-400 hover:text-white transition-colors">Patents</Link></li>
            <li><Link to="/about" className="text-zinc-400 hover:text-white transition-colors">About</Link></li>
            <li><Link to="/investors" data-testid="footer-pitch-deck-link" className="text-zinc-400 hover:text-white transition-colors">Pitch Deck</Link></li>
            <li><Link to="/newsletter" data-testid="footer-newsletter-link" className="text-zinc-400 hover:text-white transition-colors">Newsletter</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="font-mono text-xs tracking-[0.2em] uppercase text-zinc-500 mb-5">
            Get In Touch
          </p>
          <ul className="space-y-3 font-body text-sm">
            <li>
              <a href="mailto:greg@wearspray.com" className="text-zinc-400 hover:text-white transition-colors">
                greg@wearspray.com
              </a>
            </li>
            <li>
              <a href={SAFE_BAND_URL} target="_blank" rel="noopener noreferrer" className="text-zinc-400 hover:text-white transition-colors">
                Shop at SafeBandPro.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-zinc-900">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="font-mono text-xs text-zinc-600">
            © {new Date().getFullYear()} WearSpray. Patent Protected.
          </p>
          <p className="font-mono text-xs text-zinc-600 tracking-wide">
            PRECISION ENGINEERED PROTECTION
          </p>
        </div>
      </div>
    </footer>
  );
}
